import {useEffect, useState} from "react";
import {useDashboardContext} from "../dashboardContextProvider";
import {DashboardListForloebModel} from "./models/DashboardListForloebModel";
import {DashboardListUkoModel} from "./models/DashboardListForloebUkoModel";

const getDaysSinceDate = (date?: Date) => {
    if (!date || isNaN(date.getTime()))
        return undefined;

    const diffTime = new Date().getTime() - date.getTime();
    return diffTime < 0 ? 0 : Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

const useDashboardList = () => {
    const [forloebList, setForloebList] = useState<DashboardListForloebModel[]>([]);
    const [forloebListUko, setForloebListUko] = useState<DashboardListUkoModel[]>([]);
    const {state} = useDashboardContext()

    useEffect(() => {
        const kompetenceAktivitetByBrugerId = new Map(state.kompetenceAktivitet.map(x => [x.brugerId, x.sidsteAktivitetDato]));

        setForloebList(state.dashboardListData.map(forloeb => ({
            ...forloeb,
            dageSidenSidsteKompetenceAktivitet: getDaysSinceDate(kompetenceAktivitetByBrugerId.get(forloeb.brugerId))
        })));
        setForloebListUko(state.dashboardListUkoData);
    }, [state.dashboardListData, state.dashboardListUkoData, state.kompetenceAktivitet])

    return {
        forloebList: forloebList,
        forloebListUko: forloebListUko,
        isLoading: state.dashboardListDataIsLoading,
    }
}
export default useDashboardList;
